import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../variables";
import { getToken } from "../authService";

const EditDestination = ({ destination, onClose, onUpdateDestination }) => {
  const [name, setName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const api_url = `${API_URL}/destination/updateDestination`;
  const upload_url = `${API_URL}/upload`;

  useEffect(() => {
    if (destination) {
      setName(destination.destination_name || "");
      setImageURL(destination.destination_image || "");
    }
  }, [destination]);

  const uploadImage = async () => {
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const token = getToken();
      const response = await axios.post(upload_url, formData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.file_name;
    } catch (err) {
      throw new Error("Image upload failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const token = getToken();

      let uploadedImageURL = "";
      if (imageFile) {
        uploadedImageURL = await uploadImage();
      }

      const formData = {
        destination_id: destination.destination_id,
        destination_name: name,
        destination_image: uploadedImageURL || imageURL,
      };

      const response = await axios.post(api_url, formData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        onUpdateDestination(response.data); // Pass updated data back to parent
        onClose(); // Close the modal
      } else {
        throw new Error("Failed to update destination");
      }
    } catch (error) {
      setError("Failed to update destination. Please try again.");
      console.error(
        "Error updating destination:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h3 className="text-lg font-bold mb-4">Edit Destination</h3>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="name"
            >
              Destination Name
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 font-bold mb-2"
              htmlFor="image"
            >
              Destination Image
            </label>
            <input
              type="file"
              id="image"
              onChange={handleImageChange}
              className="w-full px-3 py-2 border rounded-lg"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-400 text-white px-4 py-2 rounded-lg mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-800 text-white px-4 py-2 rounded-lg"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Destination"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDestination;
